const getS0NuclideByXYCoords = ({N, Z}, nuclides) => {
    return nuclides
        .filter(n => n.N === N && n.Z === Z)
        .filter(n => n.location !== 'not shown' && n.location !== 'empty')
        .filter(n => n.s === 0)[0];
};

export default getS0NuclideByXYCoords;
